<script setup lang="ts">
definePageMeta({
  layout: "faq",
})
const route = useRoute()
const { data } = await useAsyncData(route.path, () => {
  return queryCollection("faq").path(route.path).first()
})
</script>

<template>
  <ContentRenderer v-if="data" :value="data" class="prose" />
</template>
